import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ChatBotV2DataService } from '../../../services/chat-bot-v2/chat-bot-v2.data.service';

@Component({
  selector: 'app-chat-bot-asesor-v2-upload',
  templateUrl: './chat-bot-asesor-v2-upload.component.html',
})
export class ChatBotAsesorV2UploadComponent {

  files: File[];

  cantidad = 5;

  constructor(
    public chatBotV2DS: ChatBotV2DataService,
    public dialogRef: MatDialogRef<ChatBotAsesorV2UploadComponent>,
  ) {
    this.files = new Array(this.cantidad).fill(null);
  }

  async agregarDocumentos() {
    this.chatBotV2DS.agregarFiles(this.files);
    this.dialogRef.close();
  }

  agregarFile(event: Event, index: number) {
    const inputEl = event.target as HTMLInputElement;
    const file = inputEl.files[0];
    this.files[index] = file;
  }

  dragFiles(_files: FileList) {
    const files = Array.from(_files);
    this.files.forEach((file, index) => {
      if (file) return;
      this.files[index] = files.shift();
    })
  }

}
